import router from '@/router'
import * as store from '@/store'
export const saveTokenToSession = (token: string) => {
  (window as any).sessionStorage.setItem('token', token)
}
export const getTokenBySession = () =>
  (window as any).sessionStorage.getItem('token')
export const removeTokenBySession = () => {
  (window as any).sessionStorage.removeItem('token')
}

export const closeWebview = (): void => {
  const u = (window as any).navigator.userAgent
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1
  const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  console.log('Woolive run QuitWebView')
  // For Android
  if (isAndroid) {
    try {
      (window as any).WOOLIVE_ANDROID_INTERACTION.doAction('XGGameClose')
    } catch (error) {
      console.log('woolive andorid run QuitWebView message', error)
    }
  }
  // For IOS
  if (isIOS) {
    try {
      const iosObj = {
        method: 'XGGameClose',
        params: 1
      };
      (window as any).webkit.messageHandlers.WOOLIVE_IOS.postMessage(
        JSON.stringify(iosObj)
      )
    } catch (error) {
      console.log('woolive ios run QuitWebView', error)
    }
  }
}

export const logout = () => {
  removeTokenBySession()
  store.commit('user', {})
  router.push('/login')
  setTimeout(() => {
    location.replace(location.origin + location.pathname)
  }, 200)
}
